import Image1 from "../../assets/apple-site.png";
import Image2 from "../../assets/ipl.png";
import Image3 from "../../assets/Tea-station.png";
import Image4 from "../../assets/nike-screenshot.png";
import Image5 from "../../assets/topboy-l.png";
import Image6 from "../../assets/zsi-screenshot.png";
import Image7 from "../../assets/ipl-app.png";
import Image8 from "../../assets/cpl.png";
import Image9 from "../../assets/edu.png";
import Image10 from "../../assets/real-estate.png";
import Image11 from "../../assets/thinkboard.png";

const data = [
  {
    id: 10,
    category: "frontend",
    image: Image7,
    title: "Innovation Park Limited (Bulk-SMS Website) (Frontend)",
    desc: "Made for a telecoms firm, IPL is website for their customers to get Bulk SMS service using their dashboard. ( React, Tailwind css)",
    demo: "https://harty49.github.io/ipl-app/",
    github: "https://github.com/harty49/ipl-app",
  },
  {
    id: 7,
    category: "frontend",
    image: Image10,
    title: "Homyz Real Estate website (Frontend)",
    desc: "A small website for a real estate firm called homyz showcasing their products and advertisements. ( Reactjs, framer-motion)",
    demo: "https://harty49.github.io/real-estate/",
    github: "https://github.com/harty49/real-estate",
  },
  {
    id: 8,
    category: "frontend",
    image: Image8,
    title: "Cohere Plus Limited (Frontend)",
    desc: "A full website for an IT firm advertising their services and products. ( Wordpress)",
    demo: "https://cpl.com.ng/",
    github: "/",
  },
  {
    id: 9,
    category: "backend",
    image: Image9,
    title: "Oron Development Union UK & Ireland (Frontend/Backend)",
    desc: "Updated the PHP version to the latest version and also solved compatibility issues after the update ( JAVASCRIPT, PHP)",
    demo: "https://edu.org.uk/",
    github: "/",
  },
  {
    id: 11,
    category: "backend",
    image: Image11,
    title: "ThinkBoard  (Frontend & Backend)",
    desc: "A well detailed and functional notepad used to document thoughts, experiences and also notes for future references. ( React, Express, node, tailwindcss)",
    demo: "https://mern-thinkboard-kzx1.onrender.com",
    github: "https://github.com/harty49/mern-thinkboard",
  },
  {
    id: 2,
    category: "frontend",
    image: Image2,
    title: "Innovation Park Limited (Frontend)",
    desc: "A landing page for an upcoming I.T firm to advertize their products and services (  WordPress)",
    demo: "https://ipl.com.ng",
    github: "https://github.com/",
  },
  {
    id: 1,
    category: "frontend",
    image: Image1,
    title: "Apple Landing Page (Frontend)",
    desc: "A landing page for Apple to advertise thier products (  REACT NATIVE, TAILWINDCSS)",
    demo: "https://ubiquitous-chebakia-43298f.netlify.app/",
    github: "https://github.com/",
  },
  {
    id: 5,
    category: "frontend",
    image: Image6,
    title:
      "Zamfara State Investment and Property Development Limited (Frontend)",
    desc: "A landing page for Zamfara State Investment Company, Nigeria to help procreate their business and share their services ( REACT  BOOTSTRAP)",
    demo: "https://zsipdcl.netlify.app/",
    github: "https://github.com/harty49/zamfara-state",
  },
  {
    id: 3,
    category: "frontend",
    image: Image3,
    title: "Tea Station Project (Frontend)",
    desc: "A landing site for a USA based tea company advertising thier products and services ( HTML, CSS, JAVASCRIPT, REACT)",
    demo: "https://topteastation.netlify.app/",
    github: "https://github.com/harty49/Tea-Station-Project",
  },
  {
    id: 4,
    category: "frontend",
    image: Image4,
    title: "Nike clone landing page  (Frontend)",
    desc: "A landing site for a Nike company to advertize thier shoes and products for sale (  REACT NATIVE & TAILWIND CSS )",
    demo: "https://hartmans-nike-clone.netlify.app/",
    github: "https://github.com",
  },
  {
    id: 6,
    category: "frontend",
    image: Image5,
    title: "Topboy Logistics (Frontend)",
    desc: "A landing site for a logistics company in Nigeria ( HTML, CSS, JAVASCRIPT, REACT)",
    demo: "https://topboylogistics.netlify.app/",
    github: "https://github.com/harty49/Topboy-Logistics",
  },
];

export default data;
